/* Domovoi · homepage demos (logged-out state)

   Three cut-down, working versions of the products plus the live
   feed in the hero. Vanilla, no dependencies. Nothing here talks to
   the server: titles, recipes and brands are real, but hard-coded.

   Honesty rule for the hero feed: it only shows things that really
   sync between partners today. Considered joined once the gift
   calendar shipped; anything for one of them would be hidden from
   them, so the feed only shows gifts for other people. */
(function () {
  'use strict';

  var IMG = 'https://image.tmdb.org/t/p/w342';
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------
     Hero: a couple's evening, as it happens
     ------------------------------------------------------------ */
  var FEED = [
    { k: 'catered', who: 'S', text: '<b>Sam</b> put Rigatoni Pie on Thursday' },
    { k: 'curated', who: 'AS', text: '<b>It\'s a match.</b> You both want to watch Slow Horses', img: '/AdYr4DjOgXvDUMwu6vEhZy1Rnxk.jpg' },
    { k: 'catered', who: 'A', text: '<b>Alex</b> ticked off garlic, onions and 4 more in the shop' },
    { k: 'curated', who: 'S', text: '<b>Sam</b> said yes to The Crown. It\'s at the front of Alex\'s deck', img: '/1M876KPjulVwppEpldhdc8V4o68.jpg' },
    { k: 'considered', who: 'S', text: '<b>Sam</b> confirmed a Diptyque candle for Alex\'s mum\'s birthday' },
    { k: 'catered', who: 'A', text: '<b>Alex</b> saved a Massaman curry from a link' },
    { k: 'curated', who: 'AS', text: '<b>Pick for us:</b> Ted Lasso, on Apple TV', img: '/uRHsiw1wLxPHFXkkv4Ix1s0O6f4.jpg' },
    { k: 'catered', who: 'S', text: '<b>Sam</b> planned 3 dinners. The list merged 3 onions' },
    { k: 'considered', who: 'AS', text: '<b>Jo\'s birthday</b> is in 9 days. Two ideas, nothing confirmed yet' },
    { k: 'curated', who: 'AS', text: '<b>New season</b> of Slow Horses is out. Back on your list', img: '/AdYr4DjOgXvDUMwu6vEhZy1Rnxk.jpg' },
  ];
  function orbFor(who) {
    if (who === 'AS') return '<span class="p-orbs"><span class="orb a" style="min-width:20px;height:20px;padding:0 5px;font-size:10px">A</span><span class="orb b" style="min-width:20px;height:20px;padding:0 5px;font-size:10px">S</span></span>';
    return '<span class="orb ' + (who === 'A' ? 'a' : 'b') + '" style="min-width:28px;padding:0">' + who + '</span>';
  }
  function heroFeed() {
    var list = document.getElementById('heroFeed');
    if (!list) return;
    var i = 0, items = [];
    function push() {
      var f = FEED[i % FEED.length]; i++;
      var li = el('li', 'p-feed-item k-' + f.k,
        orbFor(f.who) +
        '<span class="t">' + f.text + '</span>' +
        (f.img ? '<img class="thumb" src="' + IMG + f.img + '" alt="">' : '<span class="when">just now</span>'));
      list.insertBefore(li, list.firstChild);
      items.unshift(li);
      if (items.length > 5) {
        var old = items.pop();
        old.classList.add('out');
        setTimeout(function () { old.remove(); }, 380);
      }
    }
    // a resting state that already reads as a feed
    for (var n = 0; n < 4; n++) push();
    items.forEach(function (li) { li.style.animation = 'none'; });
    if (!reduce) setInterval(function () { if (!document.hidden) push(); }, 2800);
  }

  /* ------------------------------------------------------------
     Tabs
     ------------------------------------------------------------ */
  function tabs() {
    var btns = Array.prototype.slice.call(document.querySelectorAll('.p-tab'));
    function show(name, focus) {
      btns.forEach(function (b) {
        var on = b.dataset.demo === name;
        b.classList.toggle('active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
        document.getElementById('demo-' + b.dataset.demo).hidden = !on;
        if (on && focus) b.focus();
      });
    }
    btns.forEach(function (b, idx) {
      b.addEventListener('click', function () { show(b.dataset.demo); });
      b.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var next = btns[(idx + (e.key === 'ArrowRight' ? 1 : btns.length - 1)) % btns.length];
        show(next.dataset.demo, true);
      });
    });
    show('curated');
  }

  /* ------------------------------------------------------------
     Curated: you swipe, Sam swipes, matches land on the list
     ------------------------------------------------------------ */
  var TITLES = [
    { t: 'Slow Horses', m: 'Show · 6 seasons · Apple TV', p: '/AdYr4DjOgXvDUMwu6vEhZy1Rnxk.jpg', sam: 'yes' },
    { t: 'Peaky Blinders', m: 'Show · 6 seasons · Netflix', p: '/vUUqzWa2LnHIVqkaKVlVGkVcZIW.jpg', sam: 'no' },
    { t: 'Ted Lasso', m: 'Show · 4 seasons · Apple TV', p: '/uRHsiw1wLxPHFXkkv4Ix1s0O6f4.jpg', sam: 'yes' },
    { t: 'Knives Out', m: 'Film · 2h 11m · Prime Video', p: '/pThyQovXQrw2m0s9x82twj48Jq4.jpg', sam: 'yes' },
    { t: 'Chernobyl', m: 'Show · 1 season · Crave', p: '/hlLXt2tOPT6RRnjiUmoxyG1LTFi.jpg', sam: 'no' },
    { t: 'The Crown', m: 'Show · 6 seasons · Netflix', p: '/1M876KPjulVwppEpldhdc8V4o68.jpg', sam: 'yes' },
  ];
  function curated() {
    var stack = document.getElementById('cuStack'), them = document.getElementById('cuThem');
    if (!stack) return;
    var yesBtn = document.getElementById('cuYes'), noBtn = document.getElementById('cuNo');
    var note = document.getElementById('cuThemNote'), match = document.getElementById('cuMatch');
    var list = document.getElementById('cuList'), count = document.getElementById('cuCount');
    var i = 0, busy = false, matches = 0;

    function card(x, under) {
      var c = el('div', 'cu-card' + (under ? ' under' : ''),
        '<img src="' + IMG + x.p + '" alt="" draggable="false"><div class="cu-cap"><b>' + esc(x.t) + '</b><span>' + esc(x.m) + '</span></div>');
      return c;
    }
    function render() {
      stack.innerHTML = ''; them.innerHTML = '';
      if (i >= TITLES.length) {
        stack.appendChild(el('div', 'cu-done', '<b>' + (matches === 1 ? 'One match' : matches + ' matches') + '</b>' +
          'The real deck has over a thousand titles streaming in your country.<button class="p-btn sm" type="button" id="cuAgain">Go again</button>'));
        them.appendChild(el('div', 'cu-done', 'Sam\'s done too'));
        document.getElementById('cuAgain').onclick = reset;
        yesBtn.disabled = noBtn.disabled = true; note.textContent = '';
        return;
      }
      if (TITLES[i + 1]) stack.appendChild(card(TITLES[i + 1], true));
      var top = card(TITLES[i]); stack.appendChild(top); drag(top);
      if (TITLES[i + 1]) them.appendChild(card(TITLES[i + 1], true));
      them.appendChild(card(TITLES[i]));
      yesBtn.disabled = noBtn.disabled = false;
      note.textContent = 'Swiping on their phone';
    }
    function decide(mine) {
      if (busy || i >= TITLES.length) return;
      busy = true; yesBtn.disabled = noBtn.disabled = true;
      var x = TITLES[i];
      var top = stack.lastElementChild, theirs = them.lastElementChild;
      top.appendChild(el('div', 'cu-stamp ' + mine, mine === 'yes' ? 'Yes' : 'No'));
      top.style.transform = '';
      top.classList.add(mine === 'yes' ? 'go-yes' : 'go-no');
      setTimeout(function () {
        theirs.appendChild(el('div', 'cu-stamp ' + x.sam, x.sam === 'yes' ? 'Yes' : 'No'));
        note.textContent = x.sam === 'yes' ? 'Sam said yes' : 'Sam passed';
      }, reduce ? 0 : 450);
      setTimeout(function () {
        theirs.classList.add(x.sam === 'yes' ? 'go-yes' : 'go-no');
        var both = mine === 'yes' && x.sam === 'yes';
        if (both) {
          matches++;
          match.innerHTML = 'It\'s a match<small>You both want ' + esc(x.t) + '</small>';
          match.classList.add('show');
          var empty = list.querySelector('.cu-empty'); if (empty) empty.remove();
          var img = el('img'); img.src = IMG + x.p; img.alt = x.t; list.appendChild(img);
          count.textContent = matches;
        }
        setTimeout(function () {
          match.classList.remove('show');
          i++; busy = false; render();
        }, both ? 1300 : 350);
      }, reduce ? 50 : 950);
    }
    function reset() {
      i = 0; matches = 0; count.textContent = '0';
      list.innerHTML = '<span class="cu-empty">Matches land here, on both phones.</span>';
      render();
    }
    // drag to swipe, with the same horizontal-intent rule as the real deck
    function drag(c) {
      var sx = null, sy = 0, horiz = null, dx = 0;
      c.addEventListener('pointerdown', function (e) { if (busy) return; sx = e.clientX; sy = e.clientY; horiz = null; dx = 0; });
      c.addEventListener('pointermove', function (e) {
        if (sx === null) return;
        dx = e.clientX - sx; var dy = e.clientY - sy;
        if (horiz === null) {
          if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return;
          horiz = Math.abs(dx) > Math.abs(dy) * 1.3;
          if (!horiz) { sx = null; return; }
          try { c.setPointerCapture(e.pointerId); } catch (err) {}
        }
        c.style.transition = 'none';
        c.style.transform = 'translateX(' + dx + 'px) rotate(' + dx / 18 + 'deg)';
      });
      function end() {
        if (sx === null) return; sx = null;
        c.style.transition = '';
        if (dx > 80) decide('yes'); else if (dx < -80) decide('no'); else c.style.transform = '';
      }
      c.addEventListener('pointerup', end);
      c.addEventListener('pointercancel', function () { sx = null; c.style.transition = ''; c.style.transform = ''; });
    }
    yesBtn.addEventListener('click', function () { decide('yes'); });
    noBtn.addEventListener('click', function () { decide('no'); });
    render();
  }

  /* ------------------------------------------------------------
     Catered: plan dinners, watch the list merge
     ------------------------------------------------------------ */
  var AISLES = ['Produce', 'Meat', 'Dairy & chilled', 'Pantry'];
  var RECIPES = [
    { id: 'rig', name: 'Rigatoni pie', meta: '45 min · serves 4', sw: 'var(--coral-200)', ing: [['Rigatoni', 500, 'g', 'Pantry'], ['Chopped tomatoes', 2, 'tins', 'Pantry'], ['Onion', 1, '', 'Produce'], ['Garlic', 3, 'cloves', 'Produce'], ['Parmesan', 80, 'g', 'Dairy & chilled'], ['Mozzarella', 1, 'ball', 'Dairy & chilled']] },
    { id: 'lem', name: 'Lemon & asparagus pasta', meta: '20 min · serves 2', sw: 'var(--pistachio-200)', ing: [['Spaghetti', 400, 'g', 'Pantry'], ['Asparagus', 1, 'bunch', 'Produce'], ['Lemon', 1, '', 'Produce'], ['Garlic', 2, 'cloves', 'Produce'], ['Parmesan', 50, 'g', 'Dairy & chilled']] },
    { id: 'cur', name: 'Chickpea & squash curry', meta: '40 min · serves 4', sw: 'var(--butter-200)', ing: [['Chickpeas', 2, 'tins', 'Pantry'], ['Butternut squash', 1, '', 'Produce'], ['Onion', 1, '', 'Produce'], ['Garlic', 3, 'cloves', 'Produce'], ['Coconut milk', 1, 'tin', 'Pantry'], ['Basmati rice', 300, 'g', 'Pantry']] },
    { id: 'gno', name: 'Sausage gnocchi', meta: '30 min · serves 4', sw: 'var(--sky-200)', ing: [['Gnocchi', 500, 'g', 'Dairy & chilled'], ['Sausages', 6, '', 'Meat'], ['Cherry tomatoes', 300, 'g', 'Produce'], ['Onion', 1, '', 'Produce'], ['Parmesan', 40, 'g', 'Dairy & chilled']] },
    { id: 'mas', name: 'Massaman curry', meta: '1 hr · serves 4', sw: 'var(--plum-100)', ing: [['Beef shin', 600, 'g', 'Meat'], ['Potatoes', 4, '', 'Produce'], ['Onion', 2, '', 'Produce'], ['Coconut milk', 1, 'tin', 'Pantry'], ['Peanuts', 50, 'g', 'Pantry']] },
  ];
  var DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  function qty(n, u) {
    if (!u) return String(n);
    if (u === 'tins' || u === 'tin') return n + (n === 1 ? ' tin' : ' tins');
    if (u === 'cloves') return n + ' cloves';
    if (u === 'g') return n >= 1000 ? (n / 1000) + ' kg' : n + ' g';
    return n + ' ' + u + (n > 1 && u !== 'g' ? (u === 'bunch' ? 'es' : 's') : '');
  }
  function catered() {
    var rBox = document.getElementById('caRecipes'), wBox = document.getElementById('caWeek'), sBox = document.getElementById('caShop'), nEl = document.getElementById('caN');
    if (!rBox) return;
    var plan = [{ r: 'rig', who: 'Sam' }], prev = {}, ticked = {}, samTicked = false;

    function list() {
      var agg = {};
      plan.forEach(function (p) {
        var r = RECIPES.filter(function (x) { return x.id === p.r; })[0];
        r.ing.forEach(function (g) {
          var unit = g[2] === 'tin' ? 'tins' : g[2];
          var k = g[0] + '|' + unit;
          if (!agg[k]) agg[k] = { name: g[0], n: 0, u: unit, aisle: g[3], from: 0 };
          agg[k].n += g[1]; agg[k].from++;
        });
      });
      return agg;
    }
    function render(fresh) {
      rBox.innerHTML = '';
      RECIPES.forEach(function (r) {
        var b = el('button', 'ca-recipe', '<span class="ca-sw" style="background:' + r.sw + '">' + r.name[0] + '</span><span><b>' + esc(r.name) + '</b><span class="m">' + r.meta + '</span></span>');
        b.type = 'button';
        b.disabled = plan.length >= 7;
        b.onclick = function () { add(r.id); };
        rBox.appendChild(b);
      });
      wBox.innerHTML = '';
      DAYS.forEach(function (d, idx) {
        var p = plan[idx];
        var r = p && RECIPES.filter(function (x) { return x.id === p.r; })[0];
        var li = el('li', 'ca-day' + (r ? ' full' : ''), '<span class="d">' + d + '</span><span>' + (r ? esc(r.name) + (p.who !== 'You' ? '<span class="who">· ' + p.who + '</span>' : '') : '') + '</span>');
        if (r && idx !== fresh) li.style.animation = 'none';
        wBox.appendChild(li);
      });
      var agg = list(), keys = Object.keys(agg), n = 0;
      sBox.innerHTML = '';
      AISLES.forEach(function (a) {
        var ks = keys.filter(function (k) { return agg[k].aisle === a; }).sort();
        if (!ks.length) return;
        var g = el('div', 'ca-shop-group', '<div class="ca-aisle">' + a + '</div>');
        ks.forEach(function (k) {
          var it = agg[k]; n++;
          var cls = 'ca-item' + (ticked[k] ? ' ticked' : '') + (prev[k] == null && fresh != null ? ' new' : '') + (prev[k] != null && prev[k] !== it.n ? ' bump' : '');
          var row = el('div', cls, '<span class="box">' + (ticked[k] ? '✓' : '') + '</span><span class="n">' + esc(it.name) + (it.from > 1 ? ' <span class="muted" style="font-size:11px">×' + it.from + ' recipes</span>' : '') + '</span>' +
            (ticked[k] ? '<span class="by">' + ticked[k] + '</span>' : '') + '<span class="q">' + qty(it.n, it.u) + '</span>');
          g.appendChild(row);
        });
        sBox.appendChild(g);
      });
      nEl.textContent = n;
      if (plan.length >= 7) sBox.appendChild(el('button', 'p-btn sm', 'Clear the week')).onclick = function () { plan = [{ r: 'rig', who: 'Sam' }]; prev = {}; ticked = {}; samTicked = false; render(); };
      setTimeout(function () { sBox.querySelectorAll('.bump').forEach(function (x) { x.classList.remove('bump'); }); }, 900);
      prev = {}; keys.forEach(function (k) { prev[k] = agg[k].n; });
    }
    function add(id) {
      if (plan.length >= 7) return;
      plan.push({ r: id, who: 'You' });
      render(plan.length - 1);
      // after your second dinner, Sam ticks something off in the shop
      if (plan.length === 3 && !samTicked) {
        samTicked = true;
        setTimeout(function () { ticked['Garlic|cloves'] = 'Sam'; render(); }, reduce ? 0 : 1400);
      }
    }
    render();
  }

  /* ------------------------------------------------------------
     Considered: two questions, a real shortlist
     ------------------------------------------------------------ */
  var WHO = [['dad', 'Your dad'], ['sister', 'Your sister'], ['friend', 'A friend'], ['hosts', 'The hosts']];
  var INTO = [['cook', 'Cooking'], ['coffee', 'Coffee & tea'], ['garden', 'The garden'], ['bath', 'A long bath']];
  var INTO_WORDS = { cook: 'loves cooking', coffee: 'lives on coffee and tea', garden: 'is always in the garden', bath: 'loves a long bath' };
  var BRANDS = {
    cook: [
      { n: 'Global', c: 'Japan', d: 'Seamless stainless steel knives with the dimpled handle. The one chefs keep.', p: 2, sw: 'var(--sky-200)' },
      { n: 'Emile Henry', c: 'France', d: 'Burgundy ceramic cookware, family-run since 1850.', p: 2, sw: 'var(--butter-200)' },
      { n: 'Falcon Enamelware', c: 'U.K', d: 'The blue-and-white speckled enamel bakeware, made since 1920.', p: 1, sw: 'var(--coral-200)' },
    ],
    coffee: [
      { n: 'Ippodo Tea', c: 'Japan', d: 'Kyoto green-tea house founded in 1717. Proper matcha and sencha.', p: 1, sw: 'var(--pistachio-200)' },
      { n: 'Chemex', c: 'U.S.A', d: 'The glass pour-over coffee maker that sits in design museums.', p: 2, sw: 'var(--milk-200)' },
      { n: 'Coffee Collective', c: 'Denmark', d: 'Copenhagen roaster known for direct-trade beans.', p: 1, sw: 'var(--butter-200)' },
    ],
    garden: [
      { n: 'Niwaki', c: 'U.K', d: 'Japanese pruning saws and shears, chosen by people who garden.', p: 2, sw: 'var(--pistachio-200)' },
      { n: 'Felco', c: 'Switzerland', d: 'The secateurs every serious gardener ends up with.', p: 2, sw: 'var(--coral-200)' },
      { n: 'Haws', c: 'U.K', d: 'Birmingham watering cans with the famous long spout.', p: 1, sw: 'var(--sky-200)' },
    ],
    bath: [
      { n: 'Claus Porto', c: 'Portugal', d: 'Perfumed soap in Art Deco wrappers, made in Porto.', p: 1, sw: 'var(--coral-200)' },
      { n: 'Ikeuchi Organic', c: 'Japan', d: 'Imabari organic cotton towels, absurdly soft.', p: 2, sw: 'var(--milk-200)' },
      { n: 'Marvis', c: 'Italy', d: 'Florentine toothpaste in painted tins. An everyday thing, upgraded.', p: 1, sw: 'var(--sky-200)' },
    ],
  };
  function considered() {
    var whoBox = document.getElementById('coWho'), intoBox = document.getElementById('coInto'), out = document.getElementById('coResults');
    if (!whoBox) return;
    var who = 'dad', into = 'cook';
    function chips(box, opts, get, set) {
      box.innerHTML = '';
      opts.forEach(function (o) {
        var b = el('button', 'co-chip', esc(o[1])); b.type = 'button';
        b.setAttribute('aria-pressed', get() === o[0] ? 'true' : 'false');
        b.onclick = function () { set(o[0]); draw(); };
        box.appendChild(b);
      });
    }
    function draw() {
      chips(whoBox, WHO, function () { return who; }, function (v) { who = v; });
      chips(intoBox, INTO, function () { return into; }, function (v) { into = v; });
      var label = WHO.filter(function (w) { return w[0] === who; })[0][1];
      var lead = 'For ' + label.charAt(0).toLowerCase() + label.slice(1) + ', who ' + (who === 'hosts' ? INTO_WORDS[into].replace(/^is /, 'are ').replace(/^loves/, 'love').replace(/^lives/, 'live') : INTO_WORDS[into]);
      var html = '<p class="co-lead">' + esc(lead) + '</p><div class="co-cards">';
      BRANDS[into].forEach(function (b) {
        var dots = ''; for (var k = 1; k <= 4; k++) dots += '<i class="' + (k <= b.p ? 'on' : '') + '"></i>';
        html += '<div class="co-card"><span class="co-mono" style="background:' + b.sw + '">' + esc(b.n[0]) + '</span><b>' + esc(b.n) + '</b><span class="from">' + esc(b.c) + '</span><p>' + esc(b.d) + '</p><span class="co-price" title="Price band ' + b.p + ' of 4">' + dots + '</span></div>';
      });
      out.innerHTML = html + '</div>';
    }
    draw();
  }

  function init() { heroFeed(); tabs(); curated(); catered(); considered(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
